"use client";

import { Link } from "@/components/common/Link";
export default function Footer() {
  return <footer id="footer" className="dark bg-background text-foreground border-t-2 border-border-strong">
      <div className="max-w-screen-xl mx-auto px-8 py-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {}
          <div className="flex items-center">
            <img src="https://aware-ocelot.10web.cloud/wp-content/uploads/2026/02/logo.png" alt="FAKTA INTEGRITAS" className="!h-[100px] !w-[150px]" />
          </div>

          {}
          <div className="text-sm text-muted-foreground text-center md:text-right">
            © 2025 Fakta Integritas. All Rights Reserved.
          </div>
        </div>
      </div>
    </footer>;
}